import React, { useContext } from "react";
import {
  Container,
  FormControl,
  FormLabel,
  FormHelperText,
  Input,
  Heading,
  Box,
  Button,
  Stack,
  useToast,
  Link,
  Text,
} from "@chakra-ui/react";
import { UserContext } from "../context/UserContext";
import axios from "axios";
import { useHistory } from "react-router-dom";

const Register = () => {
  const { setLoginStatus, setUser } = useContext(UserContext);
  const toast = useToast();
  const history = useHistory();

  const submitRegister = (event) => {
    event.preventDefault();
    let name = event.target[0].value;
    let email = event.target[1].value;
    let password = event.target[2].value;

    axios
      .post(`https://backendexample.sanbersy.com/api/register`, {
        name: name,
        email: email,
        password: password,
      })
      .then((res) => {
        let data = res.data;
        setUser({
          name: data.name,
          email: data.email,
          token: data.token,
        });
        setLoginStatus(true);
        event.target[0].value = "";
        event.target[1].value = "";
        event.target[2].value = "";
        toast({
          title: "Account created.",
          description: "We've created your account for you.",
          position: "top",
          status: "success",
          duration: 3000,
        });
      })
      .then(() => {
        history.push("/login");
      });
  };

  return (
    <Box bg="gray.700" color="teal.200" p={10}>
      <Container>
        <Stack spacing="1rem">
          <Heading>Register</Heading>
          <Text>
            Already have an account?
            <Link href="/login"> Login here</Link>
          </Text>
          <form onSubmit={submitRegister}>
            <Stack spacing="1.75rem">
              <FormControl id="name" isRequired>
                <FormLabel>Full name</FormLabel>
                <Input
                  type="text"
                  aria-label="full name"
                  autoComplete="off"
                  name="name"
                />
                <FormHelperText>Please provide your full name.</FormHelperText>
              </FormControl>
              <FormControl id="email" isRequired>
                <FormLabel>Email address</FormLabel>
                <Input
                  type="email"
                  aria-label="email address"
                  autoComplete="off"
                  name="email"
                />
                <FormHelperText>
                  Please provide your active email.
                </FormHelperText>
              </FormControl>
              <FormControl id="password" isRequired>
                <FormLabel>Type your password</FormLabel>
                <Input
                  type="password"
                  aria-label="password"
                  autoComplete="off"
                  name="password"
                />
                <FormHelperText>
                  Password should be 8 characters long
                </FormHelperText>
              </FormControl>
              <Button type="submit" colorScheme="teal" variant="solid">
                Register
              </Button>
            </Stack>
          </form>
        </Stack>
      </Container>
    </Box>
  );
};

export default Register;
